import { AfterViewChecked, Component, ElementRef, Input, ViewChild } from '@angular/core';
import twemoji from 'twemoji';
import { CardInfoReport } from '../../../core/models/reports/card-info-report.model';

@Component({
  selector: 'app-card-info',
  standalone: false,
  templateUrl: './card-info.component.html',
  styleUrl: './card-info.component.scss'
})
export class CardInfoComponent implements AfterViewChecked {

  @Input() card: CardInfoReport | null = null;
  @ViewChild('container', { static: true }) container!: ElementRef;

  ngAfterViewChecked() {
    if (this.container) {
      twemoji.parse(this.container.nativeElement, { folder: 'svg', ext: '.svg' });
    }
  }
}
